<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Transport</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Transport</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Details Area -->
<div class="blog-details-area py-5">
    <div class="container">
        <div class="row match-height">
            <div class="col-12 col-md-7">
                <div class="blog-details-content">
                    <div class="blog-top-content">
                        <div class="news-content">
                            <h3 class="font-family005">SMART CARD BASED DRIVING LICENSE AND VEHICLE REGISTRATION DOCUMENT</h3>
                            <p class="font-family004">State-of-the-art security features prevent counterfeiting and fraudulent use.Future-oriented card systems will
                                mean greater mobility for most people, because they allow driving licenses to be read anywhere in the world
                                using a simple machine-based process. Cardholders benefit from compact size and robustness of the card. With
                                this system in place, travelers have the added convenience of holding a card with wide international acceptance.
                                Issuing authorities benefit chiefly from the rapid, simple verification, international readability, durability
                                and anti-forgery protection The driving license also has tactile (raised) surfaces, tactile engraved text,
                                changing colors as well as complex background designs. The smart cards come with a facility to record traffic
                                violations and details of any convictions relating to road accidents.Unique ID number – provides quick access
                                to Holders files. Smart card also prevents duplicates or fraudulent licenses. Manufacturing of Registration Certificates Card Personalization and Application Software Complete Integrated Solutions Manpower Deployment for Operations.
                            </p>
                        </div>
                        <div class="news-content font-family004 mt-3">
                            <h3 class="font-family005">DRIVING LICENSE AND REGISTRATION MANAGEMENT SOLUTIONS</h3>
                            <p> eDLVR is a web-based and modular solution designed to consolidate and simplify the various processes involved in vehicle registration and the issuance of driving licenses. 
                            <p>The solution empowers traffic police departments with an intelligent and secure mechanism that supports online registration and enrollment.</p>
                           <p>The solution is additionally available with a mobile application that can be published under the government’s eService platform.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5">
                <div class="row match-height">
                    <div class="col-12 col-md-6">
                        <img src="assets/img/services/transport.jpeg" alt="Image" class="fix">
                    </div>
                    <div class="col-12 col-md-6">
                            <img src="assets/img/services/transport3.jpg" alt="Image" class="fix">
                    </div>
                    <div class="col-12 pt-3">
                        <img src="assets/img/services/transport4.jpg" alt="Image" class="fix">
                    </div>
                </div>
            </div>
            <!-- <div class="col-12">
                <div class="blog-details-content">
                    <div class="blog-top-content">
                        <div class="news-content font-family004 pt-3">
                            <h3 class="font-family005">DRIVING LICENSE AND REGISTRATION MANAGEMENT SOLUTIONS</h3>
                            <p> eDLVR is a web-based and modular solution designed to consolidate and simplify the various processes involved in vehicle registration and the issuance of driving licenses. 
                            <p>The solution empowers traffic police departments with an intelligent and secure mechanism that supports online registration and enrollment.</p>
                           <p>The solution is additionally available with a mobile application that can be published under the government’s eService platform.</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
<!-- End Blog Details Area -->